import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { QueryClientProvider } from '@tanstack/react-query';
import i18n from './i18n';
import App from './App';
import { queryClient } from './queryClient';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const render = () => {
  root.render(
    <React.StrictMode>
        <BrowserRouter>
          <QueryClientProvider client={queryClient}>
            <I18nextProvider i18n={i18n}>
              <Suspense fallback={null}>
                <App />
              </Suspense>
            </I18nextProvider>
          </QueryClientProvider>
        </BrowserRouter>
    </React.StrictMode>
  );
};

// Wait for i18n to finish loading the detected locale before first render
// so translation keys never flash as raw strings.
if (i18n.isInitialized) {
  render();
} else {
  i18n.on('initialized', render);
}
